//@ts-nocheck
import React from 'react';
import { Table, Badge, Alert, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWarehouse,
  faCalendarAlt,
  faEdit,
  faPlus,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const StyledTable = styled(Table)`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  th {
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
    font-weight: 600;
  }

  td {
    vertical-align: middle;
  }
`;

const MaterialsUsedList = ({
  cuttingPackage,
  materialsUsed,
  onAdjustMaterial,
  onAddMaterial,
  onRemoveMaterial,
  availableItemsCount = null,
  canEdit = true,
}) => {
  return (
    <div className="mb-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-0">
          <FontAwesomeIcon icon={faWarehouse} className="me-2" />
          Materiały użyte w cięciu
          <Badge bg="secondary" className="ms-2">
            {materialsUsed.length}
          </Badge>
        </h6>
        {canEdit && cuttingPackage.status !== 'gotowy' && (
          <Button
            variant="outline-success"
            size="sm"
            onClick={() => onAddMaterial && onAddMaterial()}
            title="Dodaj nowy materiał"
          >
            <FontAwesomeIcon icon={faPlus} className="me-1" />
            Dodaj materiał
          </Button>
        )}
      </div>
      {!materialsUsed || materialsUsed.length === 0 ? (
        <Alert variant="info" className="text-center">
          <FontAwesomeIcon icon={faWarehouse} className="me-2" />
          Brak użytych materiałów
        </Alert>
      ) : (
        <StyledTable responsive>
          <thead>
            <tr>
              <th>Materiał</th>
              <th>Typ</th>
              <th className="text-center">Ilość</th>
              <th className="text-center">Data pobrania</th>
              {canEdit && <th className="text-center">Akcje</th>}
            </tr>
          </thead>
          <tbody>
            {materialsUsed.map((material, index) => (
              <tr key={index}>
                <td>
                  <strong>
                    {material.storageItem?.name || 'Nieznany materiał'}
                  </strong>
                </td>
                <td>
                  <Badge bg="primary" className="text-uppercase">
                    {material.storageItem?.type || 'Brak typu'}
                  </Badge>
                </td>
                <td className="text-center">
                  <span className="fw-bold text-primary">
                    {material.quantity}{' '}
                    {material.storageItem?.unit || 'szt.'}
                  </span>
                </td>
                <td className="text-center">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="me-1 text-muted"
                  />
                  <small className="text-muted">
                    {new Date(material.addedAt).toLocaleDateString(
                      'pl-PL',
                      {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                      },
                    )}
                  </small>
                </td>
                {canEdit && (
                  <td className="text-center">
                    <div className="d-flex gap-1 justify-content-center">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() =>
                          onAdjustMaterial &&
                          onAdjustMaterial(index, material)
                        }
                        title="Koryguj ilość materiału"
                        disabled={cuttingPackage.status === 'gotowy'}
                      >
                        <FontAwesomeIcon icon={faEdit} /> Koryguj
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() =>
                          onRemoveMaterial &&
                          onRemoveMaterial(index, material)
                        }
                        title="Usuń materiał z cięcia"
                        disabled={cuttingPackage.status === 'gotowy'}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </StyledTable>
      )}
    </div>
  );
};

export default MaterialsUsedList;
